<template>
  <div class="tips">
    <p></p>
    <div class="tips-filter">
      <div class="tips-filter-select">
        <select v-model="tips_filter_difficulty" name="tips-filter-difficulty" id="tips-filter-difficulty">
          <option value="all">{{ $t('tips.tags.all_difficulty') }}</option>
          <option value="easy">{{ $t('tips.tags.easy') }}</option>
          <option value="medium">{{ $t('tips.tags.medium') }}</option>
          <option value="hard">{{ $t('tips.tags.hard') }}</option>
        </select>
      </div>
      <div class="tips-filter-select">
        <select v-model="tips_filter_type" name="tips-filter-type" id="tips-filter-type">
          <option value="all">{{ $t('tips.tags.all_type') }}</option>
          <option value="hike">{{ $t('tips.tags.hike') }}</option>
          <option value="shop">{{ $t('tips.tags.shop') }}</option>
          <option value="eat">{{ $t('tips.tags.eat') }}</option>
          <option value="drink">{{ $t('tips.tags.drink') }}</option>
          <option value="ski">{{ $t('tips.tags.ski') }}</option>
          <option value="art">{{ $t('tips.tags.art') }}</option>
        </select>
      </div>
      <div class="tips-filter-select">
        <select v-model="tips_filter_location" name="tips-filter-location" id="tips-filter-location">
          <option value="all">{{ $t('tips.tags.all_location') }}</option>
          <option value="poprad">{{ $t('tips.tags.poprad') }}</option>
          <option value="tatra">{{ $t('tips.tags.tatra') }}</option>
          <option value="paradise">{{ $t('tips.tags.paradise') }}</option>
        </select>
      </div>
      <button class="tips-filter-button" @click="filterTags()"> {{ $t('tips.filter-button') }}</button>
    </div>
    <div class="tips-container">
      <template v-if="n === 0">
        <div class="tips-placeholder">
          <p>{{ $t('tips.no_tips') }}</p>
          <button class="tips-filter-button" @click="resetFilter()"> {{ $t('tips.reset_filter') }}</button>
        </div>
      </template>
      <template v-else>
        <div v-for="c in n" :key="c" class="tip-card">
          <div class="tip-card-image-container">
            <img :src="image_urls[c - 1]" alt="Tip 1" class="tip-card-image">
            <img :src="require(`@/assets/tips/${tip_main_tags[c - 1]}.png`)" alt="Tip 1"
              class="tip-card-image-overlay-image">
            <div class="tip-card-likes" @click.stop="handleLike(tip_names[c - 1])">
              <span class="heart-icon" :class="{ 'liked': isLiked(tip_names[c - 1]) }">❤</span>
              <span class="likes-count">{{ likes?.likes?.[tip_names[c - 1]] || 0 }}</span>
            </div>
          </div>
          <div class="tip-header" @click="openTip(c)">
            <div class="tip-card-map-icon">
              <img src="@/assets/tips/map_icon.png" alt="Map" class="tip-card-map-icon-image">
            </div>
            <h2>{{ tip_headers[c - 1] }}</h2>
          </div>
          <div class="tip-card-tags">
            <p v-for="tag in tip_tags[c - 1]" :key="tag">{{ $t(`tips.tags.${tag}`) }}</p>
          </div>
          <p v-html="tip_descriptions[c - 1]"></p>
          <div class="tip-card-footer">
            <div class="tip-card-footer-line">
              <p>{{ $t('tips.adress') }}:</p>
              <p>{{ adress[c - 1] }}</p>
            </div>
            <div class="tip-card-footer-line" @click="openTip(c)">
              <p>{{ $t('tips.travel_time') }}:</p>
              <p>{{ travel_times[c - 1] }} {{ $t(`tips.travel_mode.${travel_modes[c - 1]}`) }}</p>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { loadTips } from '@/utils/tipsimport';
import { logMessage, postLike, getLikes } from '@/utils/flaskapi';
// import { ref, onMounted } from 'vue';

export default {
  name: 'TipsView',
  data() {
    return {
      tips: {},
      n: 0,
      tip_names: [],
      tip_headers: [],
      tip_descriptions: [],
      tip_tags: [],
      image_urls: [],
      tip_main_tags: [],
      adress: [],
      adress_urls: [],
      travel_times: [],
      travel_modes: [],
      likes: {},
      likedTips: new Set(JSON.parse(localStorage.getItem('likedTips') || '[]')),
      tips_filter_difficulty: 'all',
      tips_filter_type: 'all',
      tips_filter_location: 'all',
    };
  },
  watch: {
    '$i18n.locale': {
      handler() {
        this.getTips();
      },
      immediate: true,
    }
  },
  async created() {
    this.tips = await loadTips();
    await this.getLikes(); // Get initial likes data
    this.n = Object.keys(this.tips).length;
    this.getTips();
  },
  methods: {
    async getTips(filter_tags = []) {
      await this.getLikes();
      const current_language = this.$i18n.locale;

      this.tip_names = Object.keys(this.tips);

      // Filter tips only once
              let filtered_tip_names = filter_tags.length === 0
          ? this.tip_names
          : this.tip_names.filter(tip =>
            filter_tags.every(tag => this.tips[tip].i18n.tags.includes(tag))
          );

        // Sort by likes (most likes first)
        if (this.likes?.likes) {
          filtered_tip_names.sort((a, b) => (this.likes.likes[b] || 0) - (this.likes.likes[a] || 0));
        }

        this.tip_headers = filtered_tip_names.map(
        tip => {
          const cardTitle = this.tips[tip].i18n.card?.[current_language]?.title;
          return cardTitle && cardTitle.trim() !== '' ? cardTitle : this.tips[tip].i18n.title;
        }
      );
      this.tip_descriptions = filtered_tip_names.map(
        tip => this.tips[tip].i18n.card[current_language].description
      );
      this.tip_main_tags = filtered_tip_names.map(
        tip => this.tips[tip].i18n.tag_main
      );
      this.tip_tags = filtered_tip_names.map(
        tip => this.tips[tip].i18n.tags
      );
      this.image_urls = filtered_tip_names.map(
        tip => this.tips[tip].image
      );
      this.adress = filtered_tip_names.map(
        tip => this.tips[tip].i18n.adress
      );
      this.adress_urls = filtered_tip_names.map(
        tip => this.tips[tip].i18n.adress_url
      );
      this.travel_times = filtered_tip_names.map(
        tip => this.tips[tip].i18n.travel_time
      );
      this.travel_modes = filtered_tip_names.map(
        tip => this.tips[tip].i18n.travel_mode
      );
      this.tip_names = filtered_tip_names;

      this.n = filtered_tip_names.length;

      return {
        tip_names: filtered_tip_names,
        tip_headers: this.tip_headers,
        tip_descriptions: this.tip_descriptions,
        tip_tags: this.tip_tags,
        image_urls: this.image_urls,
        tip_main_tags: this.tip_main_tags
      };
    },
    openTip(c) {
      logMessage('info', 'openTip_' + this.tip_names[c - 1]);
      // popup adress_url map location
      window.open(this.adress_urls[c - 1]);

    },
    filterTags() {
      const location = this.tips_filter_location;
      const difficulty = this.tips_filter_difficulty;
      const type = this.tips_filter_type;
      const tags = [];
      if (location !== 'all') {
        tags.push(location);
      }
      if (difficulty !== 'all') {
        tags.push(difficulty);
      }
      if (type !== 'all') {
        tags.push(type);
      }
      console.log('tags', tags);
      this.getTips(tags);
    },
    resetFilter() {
      this.tips_filter_difficulty = 'all';
      this.tips_filter_type = 'all';
      this.tips_filter_location = 'all';
      this.getTips();
    },
    async handleLike(tipName) {
      // Prevent multiple clicks if already liked
      if (this.likedTips.has(tipName)) {
        return;
      }

      try {
        await postLike(tipName);
        // Refresh likes count after successful like
        const likesData = await getLikes();
        this.likes = likesData;

        // Store the liked state
        this.likedTips.add(tipName);
        localStorage.setItem('likedTips', JSON.stringify([...this.likedTips]));
      } catch (error) {
        console.error('Failed to like tip:', error);
      }
    },

    isLiked(tipName) {
      return this.likedTips.has(tipName);
    },
    async getLikes() {
      try {
        const likes = await getLikes();
        if (likes && typeof likes === 'object') {
          this.likes = likes;
        } else {
          console.error('Invalid likes data received:', likes);
          this.likes = { likes: {} };
        }
      } catch (error) {
        console.error('Error fetching likes:', error);
        this.likes = { likes: {} };
      }
    }
  }
}
</script>

<style scoped>
.tips-placeholder {
  text-align: center;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
}

.tip-card-image-overlay-image {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: auto;
  height: auto;
  max-width: 80%;
  max-height: 80%;
  object-fit: contain;
  object-position: center;
  opacity: 1;
  z-index: 2;
  display: block;
  filter: drop-shadow(0 0 0.35rem white);
}

/* Responsive design for different screen sizes */
@media (max-width: 768px) {
  .tip-card-image-overlay-image {
    max-width: 70%;
    max-height: 70%;
  }
}

@media (max-width: 480px) {
  .tip-card-image-overlay-image {
    max-width: 60%;
    max-height: 60%;
  }
}

.tip-card-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0.95;
  color: white;
  padding: 0.5em;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  padding-bottom: 0;
  background-color: var(--primary-color);
}

.tip-card-footer-line {
  display: flex;
  justify-content: space-between;
  color: white;
}

.tip-card-footer a,
.tip-card-footer p {
  margin-left: 0.5em;
  margin-right: 0.5em;
  margin-bottom: 0.5em;
  color: white !important;
  font-size: .80rem;
  font-weight: bold;
}

.tip-card-tags {
  display: flex;
  flex-wrap: wrap;
  margin-left: 0.25em;
  justify-content: flex-start;
  margin-bottom: 0.5em;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  padding-left: 0.5em;
  height: 4.65em;
  color: white;
  border-bottom: 1px solid var(--primary-color);
  border-top: 1px solid var(--primary-color);
  font-size: 0.75rem;
}

.tip-card-tags p {
  background-color: var(--primary-color);
  white-space: nowrap;
  color: white !important;
  font-weight: bold;
  border-radius: 8px;
  margin-bottom: 0.25em;
  margin-right: 0.05em !important;
  margin-left: 0.25em !important;
  padding: 0.25rem 0.25rem;
  font-size: 0.75rem;
  height: 1.75em;

}

.tips-filter-select select {
  width: 100%;
  height: 100%;
  border: none;
  background-color: transparent;
  font-size: 1rem;
}

.tips-filter-select {
  width: 15em;
  min-width: 5em;
  height: 2.5em;
  border-radius: 8px;
  border: 1px solid var(--primary-color);
  padding: 0;
  font-size: 1rem;
  font-weight: bold;
}

.tips-filter-button {
  filter: drop-shadow(0 0 0.75rem var(--primary-color));
  background-color: var(--primary-color);
  color: white;
  border: none;
  font-size: 1rem;
  font-weight: bold;
  border-radius: 8px;
  padding: 0.5rem 1rem;
  margin: 0;
  cursor: pointer;
}

.tip-card-image-container {
  position: relative;
  width: 100%;
  height: 12em;
  border-radius: 8px;
  margin-bottom: 0.5em;
  overflow: hidden;
}

.tip-header {
  display: flex;
  align-items: center;
  gap: 0.5em;
  margin-left: 0.5em;
  margin-right: 0.5em;
}

.tip-header h2 {
  margin: 0;
  flex-grow: 1;
}

.tip-card-map-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0.2em;
}

.tip-card-map-icon:hover {
  transform: scale(1.2);
  cursor: pointer;
  transition: transform 0.3s ease;
  filter: drop-shadow(0 0 0.35rem white);
}

.tip-card-map-icon-image {
  width: 1.5em;
  height: 1.5em;
  filter: drop-shadow(0 0 0.35rem white);
}

.tip-card-likes {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: rgba(255, 255, 255, 0.9);
  padding: 4px 8px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  gap: 4px;
  z-index: 3;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.heart-icon {
  color: var(--primary-color);
  font-size: 1rem;
  transition: transform 0.2s ease;
  cursor: pointer;
}

.tip-card-likes:hover {
  filter: drop-shadow(0 0 0.35rem white);
  transform: scale(1.2);
  cursor: pointer;
  transition: transform 0.3s ease;
}

.heart-icon.liked {
  color: var(--primary-color);
  text-shadow: 0 0 2px rgba(255, 0, 0, 0.3);
}

.likes-count {
  color: var(--primary-color);
  font-weight: bold;
  font-size: 0.9rem;
}

.tip-card-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  object-fit: cover;
  object-position: center;
  opacity: 0.25;
  z-index: 1;
}

.tips {
  padding: 2rem;
  padding-top: var(--header-height, 100px);
  max-width: 1200px;
  margin: auto;
}

.tips-filter {
  margin-top: 2rem;
  border-top: 1px solid var(--primary-color);
  border-bottom: 1px solid var(--primary-color);
  margin-bottom: 2rem;
  text-align: center;
  padding-top: 1rem;
  padding-bottom: 0.5rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
}

.tips-container {
  max-width: 1200px;
  margin: 0 auto;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
}

.tip-card {
  background: whitesmoke;
  width: 20em;
  height: 31.5em;
  border-radius: 8px;
  padding: 0rem;
  margin-bottom: 0rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  position: relative;
}

.tip-card:hover {
  transform: scale(1.005);
  transition: transform 0.3s ease;
  cursor: pointer;
}

.tip-card h2 {
  color: var(--primary-color);
}

.tip-card p {
  color: #666;
  line-height: 1;
  margin-left: 1em;
  margin-right: 0.5em;
}
</style>
